export const DOCUMENT_EMAIL_MARK = "nuage-document-email:1";

type DocumentCopy = {
  id: string;
  name: string;
  subject: string;
  heading: string;
  lead: string;
};

const COPIES: DocumentCopy[] = [
  { id: "document_quotation", name: "Quotation", subject: "Quotation {{receiptNumber}} - {{storeName}}", heading: "Quotation", lead: "This is a price offer from {{storeName}}." },
  { id: "document_quotation_fr", name: "Soumission", subject: "Soumission {{receiptNumber}} - {{storeName}}", heading: "Soumission", lead: "Ceci est une offre de prix de {{storeName}}." },
  { id: "document_quotation_revised", name: "Revised quotation", subject: "Revised quotation {{receiptNumber}} - {{storeName}}", heading: "Revised quotation", lead: "This quotation replaces the previous one." },
  { id: "document_quotation_revised_fr", name: "Soumission révisée", subject: "Soumission révisée {{receiptNumber}} - {{storeName}}", heading: "Soumission révisée", lead: "Cette soumission remplace la précédente." },
  { id: "document_estimate", name: "Estimate", subject: "Estimate {{receiptNumber}} - {{storeName}}", heading: "Estimate", lead: "These amounts can still change. A closing receipt follows when the work is finished." },
  { id: "document_estimate_fr", name: "Estimation", subject: "Estimation {{receiptNumber}} - {{storeName}}", heading: "Estimation", lead: "Ces montants peuvent encore changer. Un reçu de fermeture suit à la fin des travaux." },
  { id: "document_estimate_revised", name: "Revised estimate", subject: "Revised estimate {{receiptNumber}} - {{storeName}}", heading: "Revised estimate", lead: "This estimate replaces the previous one." },
  { id: "document_estimate_revised_fr", name: "Estimation révisée", subject: "Estimation révisée {{receiptNumber}} - {{storeName}}", heading: "Estimation révisée", lead: "Cette estimation remplace la précédente." },
  { id: "document_estimate_cancelled", name: "Cancelled estimate", subject: "Cancelled estimate {{receiptNumber}} - {{storeName}}", heading: "Cancelled estimate", lead: "This estimate is cancelled. The amount is $0.00." },
  { id: "document_estimate_cancelled_fr", name: "Estimation annulée", subject: "Estimation annulée {{receiptNumber}} - {{storeName}}", heading: "Estimation annulée", lead: "Cette estimation est annulée. Le montant est de 0,00 $." },
  { id: "document_contract", name: "Contract", subject: "Contract {{receiptNumber}} - {{storeName}}", heading: "Contract", lead: "This agreement is sent as an estimate. A closing receipt follows when the service is done." },
  { id: "document_contract_fr", name: "Contrat", subject: "Contrat {{receiptNumber}} - {{storeName}}", heading: "Contrat", lead: "Cette entente est envoyée comme une estimation. Un reçu de fermeture suit quand le service est rendu." },
];

function htmlFor(copy: DocumentCopy): string {
  return `<!DOCTYPE html>
<html>
<head><meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"></head>
<body style="margin:0;padding:0;background:#f3f5f8;">
<!-- ${DOCUMENT_EMAIL_MARK} -->
<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:#f3f5f8;">
<tr><td align="center" style="padding:24px 12px;">
  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="max-width:560px;">
    <tr><td style="background:#ffffff;border-radius:12px;border-top:4px solid #0ea5e9;padding:24px;font-family:Arial,Helvetica,sans-serif;">
      <div style="font-size:20px;font-weight:bold;color:#111827;">${copy.heading}</div>
      <div style="font-size:14px;color:#6b7280;padding-top:4px;">{{storeName}}</div>
      <p style="font-size:15px;line-height:22px;color:#374151;">${copy.lead}</p>
      {{receiptBody}}
    </td></tr>
  </table>
</td></tr>
</table>
</body>
</html>`;
}

export const DOCUMENT_EMAIL_TEMPLATES = COPIES.map((copy) => ({
  id: copy.id,
  name: copy.name,
  subject: copy.subject,
  htmlContent: htmlFor(copy),
  group: "document" as const,
}));
